/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import { isRangeSetting, isEnumSetting } from "../../utils/isRangeEnumSetting";
import RangeSetting from "../setting-type/rangeSetting";
import EnumSetting from "../setting-type/enumSetting";

export default function EncodeSettings(props) {
  const { encodeSettings, handleSettingModified } = props;
  console.debug("encodeSettings", encodeSettings);
  return Object.keys(encodeSettings).map((key, index) => {
    const setting = encodeSettings[key];
    if (isEnumSetting(setting) && setting.AllowedValues.length > 0) {
      return (
        <Box sx={{ mt: 1 }} key={`${index}-enum`}>
          <EnumSetting name={key} setting={setting} handleSettingModified={handleSettingModified}/>
          <Divider />
        </Box>
      );
    }
    if (isRangeSetting(setting) && setting.Max !== "" && setting.Min !== "") {
      return (
        <Box sx={{ mt: 1 }} key={`${index}-range`}>
          <RangeSetting name={key} setting={setting} handleSettingModified={handleSettingModified}/>
          <Divider />
        </Box>
      );
    }
  });
}

EncodeSettings.propTypes = {
  encodeSettings: PropTypes.shape({}).isRequired,
	handleSettingModified: PropTypes.func.isRequired,
};
